




















import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { Tabs, TabPane } from 'element-ui';
import { AcgnStatics, AcgnStaticsStaff, AcgnStaticsMenu, AcgnGroupEdit } from '@/components';

// 组件申明
@Component({
  components: {
    AcgnStatics,
    AcgnStaticsStaff,
    AcgnStaticsMenu,
    AcgnGroupEdit,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  mixins: [RenderMenuMixin]
})

/**
 * 项目数据
 */
export default class StatisticComic extends Vue {

  private comicId: number = 0; // 漫画id
  private activeName: string = 'first';

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic" comicId={this.comicId}></acgn-statics-menu>
    );
  }

  private created() {
    this.comicId = parseInt(this.$route.params.id, 0);
  }
}
